import { ExtractionStatus } from "@inrev/common";
import { type FC } from "react";
import { UploadedDocumentRow } from "./types";

type WipExtractionDeleteDialogContentProps = {
	row: UploadedDocumentRow;
};

export const WipExtractionDeleteDialogContent: FC<WipExtractionDeleteDialogContentProps> = ({
	row,
}) => {
	const ext = row.wipExtraction;
	const fileLabel = [row.file.name, row.file.extension].join(".");

	if (!ext) {
		return (
			<div className="w-[375px] text-center break-words">
				Are you sure you want to delete
				<br />
				{fileLabel}?
			</div>
		);
	}

	return (
		<div className="w-full max-w-lg space-y-3 text-left">
			<p className="text-[15px] text-primary">
				Delete <span className="font-medium">{fileLabel}</span>? This will also permanently remove
				the associated WIP extraction and cannot be undone.
			</p>
			<dl className="space-y-1 text-sm text-secondary">
				<div className="flex gap-2">
					<dt className="font-medium text-primary">Status:</dt>
					<dd>{ExtractionStatus.displayName(ext.status)}</dd>
				</div>
			</dl>
		</div>
	);
};
